import React from 'react';
import { useRecoilState } from 'recoil';
import { openRaidIdState } from '@atom/raid/raidState';
import RaidDetailModal from './RaidDetailModal';

/**
 * 전역에서 접근 가능한 레이드 모달
 * openRaidIdState를 통해 어디서든 레이드 모달을 열 수 있음
 */
function GlobalRaidModal() {
  const [openRaidId, setOpenRaidId] = useRecoilState(openRaidIdState);

  if (!openRaidId) return null;

  return (
    <RaidDetailModal raidId={openRaidId} onClose={() => setOpenRaidId(null)} />
  );
}

export default GlobalRaidModal;
